import { Socket } from 'rete';
export default new Socket('any');
